export default {
    fetch: {
        error: null,
        isLoading: false,
        isLoaded: false,
    },
};
